import { createContext, useContext, useState, ReactNode } from "react";

interface SidebarContextType {
  sidebarWidth: number;
  isSidebarHovered: boolean;
  setIsSidebarHovered: (hovered: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);
  const sidebarWidth = isSidebarHovered ? 250 : 80;

  return (
    <SidebarContext.Provider value={{ sidebarWidth, isSidebarHovered, setIsSidebarHovered }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

